import { Injectable, EventEmitter } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "../utility/http.client";

@Injectable()
export class OrderService {
  refreshHeaderData: EventEmitter<any> = new EventEmitter();

  constructor(private http: HttpClient) { }

  createOrder(data: any): Observable<any> {
    return this.http.post("/orders/createOrder", data);
  }
  createCustomDocument(data: any): Observable<any> {
    return this.http.post("/orders/createCustomDocument", data);
  }
  createIntraOrder(data: any): Observable<any> {
    return this.http.post("/inttra/createOrder", data);
  }
  fetchOrders(data: any): Observable<any> {
    return this.http.get("/orders/fetchOrders", data);
  }
  fetchToDoOrders(data: any): Observable<any> {
    return this.http.get("/orders/fetchToDoOrders", data);
  }

  sendEBConfirmation(data: any): Observable<any> {
    return this.http.post("/orders/sendEBConfirmation", data);
  }

  updateDocOrder(data: any): Observable<any> {
    return this.http.post("/orders/uploadDocOrder", data);
  }

  uploadFiles(data: any): Observable<any> {
    return this.http.post("/orders/uploadFiles", data);
  }

  uploadBLForm(data: any): Observable<any> {
    return this.http.post("/orders/uploadBLForm", data);
  }

  sendDocumentMail(data: any): Observable<any> {
    // connectableObservableDescriptor.lo
    return this.http.post("/orders/sendDocMail", data);
  }

  getOrderDetails(data: any): Observable<any> {
    return this.http.get("/orders/getOrderDetails", data);
  }
  getCarrierTypes(data: any): Observable<any> {
    return this.http.post("/orders/getCarrierTypes", data);
  }
  getMoveTypes(data: any): Observable<any> {
    return this.http.get("/orders/getMoveTypes", data);
  }
  getCountries(data: any): Observable<any> {
    return this.http.post("/orders/getCountries", data);
  }

  getChargeTypes(data: any): Observable<any> {
    return this.http.get("/orders/getChargeTypes", data);
  }
  getPayerTypes(data: any): Observable<any> {
    return this.http.get("/orders/getPayerTypes", data);
  }
  getCurrencies(data: any): Observable<any> {
    return this.http.post("/orders/getCurrencies", data);
  }
  getContainerTypes(data: any): Observable<any> {
    return this.http.post("/orders/getContainerTypes", data);
  }
  getPackageTypes(data: any): Observable<any> {
    return this.http.post("/orders/getPackageTypes", data);
  }
  markOrderField(data: any): Observable<any> {
    return this.http.post("/orders/markOrderField", data);
  }

  removeFile(data: any): Observable<any> {
    return this.http.post("/orders/removeFile", data);
  }
  saveShippingInstriction(data: any): Observable<any> {
    return this.http.post("/orders/saveShippingInstriction", data);
  }

  saveBranch(data: any): Observable<any> {
    return this.http.post("/orders/saveBranch", data);
  }
  updateOrder(data: any): Observable<any> {
    return this.http.post("/orders/updateOrder", data);
  }

  updateBL(data: any): Observable<any> {
    return this.http.post("/orders/updateBL", data);
  }

  updateVGM(data: any): Observable<any> {
    return this.http.post("/orders/updateVGM", data);
  }

  updateCustom(data: any): Observable<any> {
    return this.http.post("/orders/updateCustom", data);
  }
  updateImportCustom(data: any): Observable<any> {
    return this.http.post("/orders/updateImportCustom", data);
  }
  getBLDetails(data: any): Observable<any> {
    return this.http.get("/orders/getBLDetails/" + data._id, {});
  }

  getCustomDetails(data: any): Observable<any> {
    return this.http.get("/orders/getCustomDetails/" + data._id, {});
  }

  getVGMDetails(data: any): Observable<any> {
    return this.http.get("/orders/getVGMDetails/" + data._id, {});
  }

  getBranch(data: any): Observable<any> {
    return this.http.post("/orders/getBranch", data);
  }

  updateBranch(data: any): Observable<any> {
    return this.http.post("/orders/updateBranch", data);
  }
  uploadBranchFiles(data: any): Observable<any> {
    return this.http.post("/orders/uploadBranchFiles", data);
  }
  fetchNotification(data: any): Observable<any> {
    return this.http.get("/orders/fetchNotification", data);
  }
  seenNotificaton(data: any): Observable<any> {
    return this.http.post("/orders/seenNotificaton", data);
  }

  getTCLExport(data: any): Observable<any> {
    return this.http.get("/orders/getTCLExport/" + data.orderId + "/" + data.tclId, {});
  }

  updateTCLExport(data: any): Observable<any> {
    return this.http.post("/orders/updateTCLExport", data);
  }

  downloadBLForm(data: any): Observable<any> {
    return this.http.getFile(
      "/orders/downloadBL",
      {}
    );
  }

  downloadOrderFiles(data: any): Observable<any> {
    return this.http.getFile(
      "/orders/downloadOrderFiles",
      data
    );
  }
  // /orders/removeBL/{blId}:
  removeBL(blId: any): Observable<any> {
    return this.http.get("/orders/removeBL/" + blId, {});
  }
  removeImportCustoms(updateObj: any): Observable<any> {
    return this.http.post("/orders/removeImportCustoms", updateObj)
  }
  saveNotes(data: any): Observable<any> {
    return this.http.post("/orders/saveNotes", data)
  }
  getHsCode(data: any): Observable<any> {
    return this.http.post("/orders/getHsCode", data);
  }

  updateData(data: any): Observable<any> {
    return this.http.post("/orders/updateData", data);
  }

/* eVGM code by AMIT */
  getEVGMDetails(data: any): Observable<any> {
    return this.http.get("/orders/getVGMDetails"+ data._id, {});
  }

  uploadEVGMDetail(data: any): Observable<any> {
    return this.http.post("/orders/getVGMDetails"+data, {});
  }

  updateEVGM(data: any): Observable<any> {
    return this.http.post("/orders/updateVGM", data);
  }

  saveEVGM(data: any): Observable<any> {
    return this.http.post("/orders/createevgmXML", data);
  }


/************************/
  chargesData() {
    return [
      {
        "name": "Additional Charges",
        "value": "AdditionalCharges"
      },
      {
        "name": "Basic Freight",
        "value": "BasicFreight"
      },
      {
        "name": "Destination Haulage Charges",
        "value": "DestinationHaulageCharges"
      },
      {
        "name": "Destination Port Charges",
        "value": "DestinationPortCharges"
      },
      {
        "name": "Origin Port Charges",
        "value": "OriginPortCharges"
      },
      {
        "name": "Origin Haulage Charges",
        "value": "OriginHaulageCharges"
      }]}
  clausesData() {
    return [
      {
        "enumeration": "01",
        "annotation": "Shipper's Load and Count"
      },
      {
        "enumeration": "02",
        "annotation": "Shipper's Load, Stowage and Count"
      },
      {
        "enumeration": "03",
        "annotation": "Laden on Board"
      },
      {
        "enumeration": "04",
        "annotation": "Laden on Board Vessel"
      },
      {
        "enumeration": "05",
        "annotation": "Vessel Not Responsible for Freezing"
      },
      {
        "enumeration": "06",
        "annotation": "Container(s) Sealed by Shipper"
      },
      {
        "enumeration": "07",
        "annotation": "On Deck at Shipper's Risk"
      },
      {
        "enumeration": "08",
        "annotation": "Short-Shipped"
      },
      {
        "enumeration": "09",
        "annotation": "Sea Waybill"
      },
      {
        "enumeration": "10",
        "annotation": "This Shipment is Effected under a Sea Waybill"
      },
      {
        "enumeration": "11",
        "annotation": "Memo Bill of Lading Only"
      },
      {
        "enumeration": "12",
        "annotation": "Refrigerated Cargo"
      }, {
        "enumeration": "13",
        "annotation": "Cool Cargo"
      },
      {
        "enumeration": "14",
        "annotation": "Freeze Cargo"
      },
      {
        "enumeration": "15",
        "annotation": "Inland Transportation Arranged as Agents Only with such Arranged Transportation Being Solely for Account and Risk of Cargo"
      },
      {
        "enumeration": "16",
        "annotation": "Sea-Air Cargo"
      },
      {
        "enumeration": "17",
        "annotation": "Freight Prepaid"
      },
      {
        "enumeration": "18",
        "annotation": "Freight Collect"
      },
      {
        "enumeration": "19",
        "annotation": "Freight as Agreed"
      },
      {
        "enumeration": "20",
        "annotation": "No Shipper's Export Declaration Required (Section 30.39)"
      },
      {
        "enumeration": "21",
        "annotation": "Carrier Reserves the Right to Place Container(s) in Heated Warehouse at a Set Cost"
      },
      {
        "enumeration": "22",
        "annotation": "On Board Rail"
      },
      {
        "enumeration": "23",
        "annotation": "On Board Truck"
      },
      {
        "enumeration": "24",
        "annotation": "On Board Vessel"
      },
      {
        "enumeration": "25",
        "annotation": "Received For Shipment"
      },
      {
        "enumeration": "26",
        "annotation": "On Board Container"
      },
      {
        "enumeration": "29",
        "annotation": "Emergency Response Statement"
      },
      {
        "enumeration": "30",
        "annotation": "International Maritime Organization Certification"
      },
      {
        "enumeration": "32",
        "annotation": "Destination Control Statements"
      },
      {
        "enumeration": "33",
        "annotation": "Producing Country of Origin"
      },
      {
        "enumeration": "34",
        "annotation": "Laden on Board Named Vessel"
      },
      {
        "enumeration": "35",
        "annotation": "Age of Vessel"
      },
      {
        "enumeration": "38",
        "annotation": "Certification Statements"
      },
      {
        "enumeration": "39",
        "annotation": "Destination Country Final destination of the shipment"
      },
      {
        "enumeration": "40",
        "annotation": "Title Passage Clause"
      },
      {
        "enumeration": "41",
        "annotation": "Container Safety Act"
      },
      {
        "enumeration": "45",
        "annotation": "General Agreement on Tariff and Trade (GATT)"
      },
      {
        "enumeration": "46",
        "annotation": "Prior Damage Remarks"
      },
      {
        "enumeration": "CB",
        "annotation": "Caribbean Basin Initiative (CBI)"
      },
      {
        "enumeration": "CC",
        "annotation": "Custom"
      },
      {
        "enumeration": "CP",
        "annotation": "Container Packing Certificate"
      },
      {
        "enumeration": "DC",
        "annotation": "Disclaimer"
      },
      {
        "enumeration": "DV",
        "annotation": "Delivery Order Liability Clause"
      },
      {
        "enumeration": "GS",
        "annotation": "General System of Preferences (GSP)"
      },
      {
        "enumeration": "IS",
        "annotation": "Israeli Free Trade Agreement"
      },
      {
        "enumeration": "NF",
        "annotation": "North American Free Trade Agreement (NAFTA)"
      },
    ]
  }
}
